export const Category_ClinicalNotes = 'clinical-notes';
export const FHIR_Binary_CategoryOptions = [
    Category_ClinicalNotes,
];
export const FHIR_Binary_CategoryOptions_ToLabelsMap = {
    [Category_ClinicalNotes]: 'Clinical Notes',
};
//# sourceMappingURL=consts.js.map